module.exports = __webpack_public_path__ + "static/img/15bg_3.43be62d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/15bg_3.png
// module id = 661
// module chunks = 1